import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@core/api/client'

export const musicGenreService = {
	/**
	 * Get all music genres
	 */
	getMusicGenres(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/music_genres', config)
	},
}

export default musicGenreService
